import { createFileRoute } from '@tanstack/react-router'
import { AuthScreen, Card } from '@dss/design-system'

/** OIDC redirect callback `/auth/callback`.
 *
 *  AuthProvider.tsx (см. @dss/auth) автоматически детектит `window.location.pathname`
 *  заканчивается на `/auth/callback` и обрабатывает code+state через `signinCallback()`,
 *  затем `history.replaceState({}, '', '/')` — пользователь уходит на /.
 *
 *  Этот компонент — просто loading-fallback на доли секунды между приёмом code'а
 *  и редиректом. */
export const Route = createFileRoute('/auth/callback')({
  component: CallbackScreen,
})

function CallbackScreen() {
  return (
    <AuthScreen>
      <Card padding="lg" radius="md">
        <div role="status" aria-live="polite" style={{ textAlign: 'center' }}>
          <p style={{ margin: 0, fontSize: 14, color: 'var(--color-text-secondary)' }}>
            Завершаем вход…
          </p>
        </div>
      </Card>
    </AuthScreen>
  )
}
